import { useMutation } from '@sequencehq/api'
import { dashboard20240730Client } from '@sequencehq/api/dashboard/v20240730'
import {
  SequenceMenu,
  useNotifications,
  SimpleModal
} from '@sequencehq/core-components'
import { usePermissions } from 'lib/rbac'
import { useState } from 'react'

const DeleteInvoiceModal = (props: {
  invoiceId: string
  onSuccess?: () => void
  onClose: () => void
}) => {
  const { displayNotification } = useNotifications()

  const deleteInvoiceMutation = useMutation(
    dashboard20240730Client.deleteInvoice,
    {
      onSuccess: () => {
        displayNotification('Invoice deleted', {
          type: 'success'
        })
      },
      onError: () => {
        displayNotification('Failed to delete invoice', {
          type: 'error'
        })
      }
    }
  )

  return (
    <SimpleModal
      data-testid="invoices.archiveInvoice.modal"
      variant="dialog"
      title="Delete invoice"
      submitButtonText="Delete invoice"
      isOpen
      onClose={props.onClose}
      submittingButtonText="Deleting..."
      onSubmit={async () => {
        await deleteInvoiceMutation.mutateAsync({ invoiceId: props.invoiceId })
        props.onSuccess?.()
        return true
      }}
    >
      This will delete the invoice immediately. This action cannot be undone.
    </SimpleModal>
  )
}

export const DeleteInvoice = (props: {
  invoiceId: string
  onSuccess?: () => void
}) => {
  const [isOpen, setIsOpen] = useState(false)
  const { can } = usePermissions()

  if (!can('org.invoice:update')) {
    return null
  }

  return (
    <>
      <SequenceMenu.Item
        destructive
        data-testid="invoices.archiveInvoice.menuItem"
        uuid="archive-invoice"
        label="Delete invoice"
        onClick={e => {
          e.stopPropagation()
          setIsOpen(true)
        }}
      />
      {isOpen && (
        <DeleteInvoiceModal
          invoiceId={props.invoiceId}
          onSuccess={props.onSuccess}
          onClose={() => setIsOpen(false)}
        />
      )}
    </>
  )
}
